var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"t-header"},[_c('span',{staticClass:"t-header__reset",on:{"click":function($event){return _vm.resetFilters('buildList')}}},[_vm._v("Cбросить все фильтры")])]),_vm._t("default",null,{"bus":_vm.bus})],2)}
var staticRenderFns = []

export { render, staticRenderFns }